// Centralized experiences data for Aspire Ventures
const experiences = [
  {
    id: 1,
    name: "Kayaking",
    description:
      "Navigate through serene backwaters and mangroves, discovering hidden coves and observing local wildlife in their natural habitat",
    image: "/kayaking.png",
    location: "North Goa",
    phone: "tel:+91-9876543210",
  },
  {
    id: 2,
    name: "Paragliding",
    description:
      "Soar high above the beautiful coastline and get a bird's eye view of Goa's stunning beaches and lush landscapes",
    image: "/paragliding.png",
    location: "North Goa",
    phone: "tel:+91-9876543211",
  },
  {
    id: 3,
    name: "Dolphin Safari",
    description:
      "Set sail on the azure waters for an unforgettable dolphin watching experience with refreshments and scenic coastal views",
    image: "/dolphin-safari.png",
    location: "North Goa",
    phone: "tel:+91-9876543212",
  },
  {
    id: 4,
    name: "Water Sports",
    description: "Experience the thrill of jet skiing, banana boat rides, and more on Goa's vibrant beaches.",
    image: "/water-sports.jpg",
    location: "North Goa",
    phone: "tel:+918668585545",
  },
  {
    id: 5,
    name: "ATV Bike Trail",
    description: "Ride through rugged trails and scenic landscapes on an exciting ATV adventure.",
    image: "/atv-bike-trail.jpg",
    location: "South Goa",
    phone: "tel:+918668585545",
  },
  {
    id: 6,
    name: "Paramotoring",
    description: "Soar above the coastline with a powered paraglider for breathtaking aerial views.",
    image: "/paramotoring.jpg",
    location: "North Goa",
    phone: "tel:+918668585545",
  },
  {
    id: 7,
    name: "Bungee Jumping",
    description: "Take the leap and feel the adrenaline rush with Goa's top bungee jumping experience.",
    image: "/bungee-jumping.jpg",
    location: "South Goa",
    phone: "tel:+918668585545",
  },
  {
    id: 8,
    name: "Waterfall",
    description: "Discover hidden waterfalls and enjoy a refreshing dip in nature's pools.",
    image: "/waterfall.jpg",
    location: "North Goa",
    phone: "tel:+918668585545",
  },
  {
    id: 9,
    name: "Spice Plantation",
    description: "Tour lush spice plantations and learn about Goa's rich agricultural heritage.",
    image: "/spice-plantation.jpg",
    location: "South Goa",
    phone: "tel:+918668585545",
  },
  {
    id: 10,
    name: "Hindu Temple",
    description: "Visit ancient temples and experience the spiritual side of Goa.",
    image: "/hindu-temple.jpg",
    location: "North Goa",
    phone: "tel:+918668585545",
  },
  {
    id: 11,
    name: "Churches",
    description: "Explore Goa's historic churches, a blend of stunning architecture and rich history.",
    image: "/churches.jpg",
    location: "South Goa",
    phone: "tel:+918668585545",
  },
  {
    id: 12,
    name: "Sunset Cruise",
    description: "Relax on a scenic cruise and watch the sun set over the Arabian Sea.",
    image: "/sunset-cruise.jpg",
    location: "North Goa",
    phone: "tel:+918668585545",
  },
];

export default experiences;
